import './Layout.scss';

import * as React from 'react';
import Helmet from 'react-helmet';

import { toArray } from 'utils/collections';

import Banner from 'components/Banner';
import Header from 'components/Header';
import Footer from 'components/Footer';

type Props = {
  title: string | Array<string> | null;
  children?: React.ReactNode;
  description?: string;
  openGraphImageUrl?: string;
  backLinkText?: string;
  backLinkTo?: string;
};

export default class Layout extends React.Component<Props> {
  static defaultProps = {
    description:
      'XOXO was an experimental festival for independent artists who live and work online.',
    openGraphImageUrl: 'https://xoxofest.com/XOXO-2024-Card.jpg',
  };

  render() {
    const {
      title,
      children,
      description,
      openGraphImageUrl,
      backLinkText,
      backLinkTo,
    } = this.props;

    const titleText = toArray(title).concat('XOXO').join(' · ');

    return (
      <div>
        <Helmet>
          <title>{titleText}</title>

          <html lang="en" />
          <meta charSet="utf-8" />
          <link href="/favicon.ico" rel="shortcut icon" />
          <meta property="og:site_name" content="XOXO" />
          <meta property="og:title" content={titleText} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={openGraphImageUrl} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@XOXO" />
          <meta name="twitter:title" content={titleText} />
          <meta name="twitter:description" content={description} />
          <meta name="twitter:image" content={openGraphImageUrl} />
        </Helmet>

        <Header backLinkText={backLinkText} backLinkTo={backLinkTo} />
        {children}

        <Footer />
      </div>
    );
  }
}
